import * as React from 'react';
import _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import TransparentButton from '../Buttons/TransparentButton';
import * as oauthAPI from '../../../apis/oauthAPI';

const styles = StyleSheet.create({
  contextLink: {
    textDecoration: 'none',
  },
});

export default class SignOutButton extends React.PureComponent {
  render() {
    return (
      <div className={css(styles.contextLink)} onClick={_e => oauthAPI.formLogout()}>
        <TransparentButton text="Sign out" />
      </div>
    );
  }
}
